import React from 'react';
import avatarStars from '../assets/avatar-stars.svg';
import avatarStarsWhite from '../assets/avatar-stars-white.svg';
import iconExpand from '../assets/icon-expand.svg';
import iconRefresh from '../assets/icon-refresh.svg';
import iconClose from '../assets/icon-close.svg';
import iconError from '../assets/icon-error.svg';

interface IconProps {
  size?: number;
  alt?: string;
}

function FigmaIcon({
  src,
  size = 20,
  alt = '',
}: IconProps & { src: string }) {
  return (
    <img
      src={src}
      alt={alt}
      width={size}
      height={size}
      style={{ display: 'block', width: size, height: size }}
    />
  );
}

export function AIAgentAvatarStarsIcon({ size = 20 }: IconProps) {
  return <FigmaIcon src={avatarStars} size={size} alt="" />;
}

export function AIAgentAvatarStarsWhiteIcon({ size = 16 }: IconProps) {
  return <FigmaIcon src={avatarStarsWhite} size={size} alt="" />;
}

export function AIAgentExpandIcon({ size = 14 }: IconProps) {
  return <FigmaIcon src={iconExpand} size={size} alt="" />;
}

export function AIAgentRefreshIcon({ size = 14 }: IconProps) {
  return <FigmaIcon src={iconRefresh} size={size} alt="" />;
}

export function AIAgentCloseIcon({ size = 14 }: IconProps) {
  return <FigmaIcon src={iconClose} size={size} alt="" />;
}

export function AIAgentErrorIcon({ size = 14 }: IconProps) {
  return <FigmaIcon src={iconError} size={size} alt="" />;
}
